<template>
  <div class="login">
    <div class="login-box">
      <v-tooltip v-model="show" bottom>
        <template v-slot:activator="{ on, attrs }">
          <img
            v-bind="attrs"
            v-on="on"
            :src="brand.logo"
            alt="Logo Gestão Afiliados"
            class="logo mb-5"
          />
          <span class="d-flex justify-center mb-2"> {{ $t('cadastro.title') }} </span>
        </template>
        <span> v.{{ appVersion }}</span>
      </v-tooltip>

      <p class="sub-title"> {{ $t('cadastro.subtitle') }} </p>


      <!-- <v-toolbar-title 
        style="
        font-size: 31px;
        text-align: center;
        width: 100%;
        color: rgb(255, 255, 255);
        font-weight: 100;
        text-transform: uppercase;
        margin-bottom: 1.3rem;
        position: relative;
        z-index: 999999
        ">
        Gestao 
      <v-tooltip v-model="show" right>
        <template v-slot:activator="{ on }">
          <strong @mouseover="show = true" @mouseout="show = false" style="font-weight: 800;"> Única </strong>
        </template>
        <span> v.{{ appVersion }}</span>
      </v-tooltip>

    </v-toolbar-title> -->
     
      <v-card class="card-login">
        <v-form>
          <v-card-text>
            <v-text-field 
              class="item mb-3"
              color="white"
              persistent-hint
              outlined
              prepend-inner-icon="mdi-account-circle-outline"
              :label="$t('cadastro.nome')"
              v-model="user.name"
              dense
              filled
              :error-messages="nameErrors"
              @input="$v.user.name.$touch()"
              @blur="$v.user.name.$touch()" />

            <v-text-field 
              class="item mb-3"
              color="white"
              persistent-hint
              outlined
              prepend-inner-icon="mdi-at"
              :label="$t('auth.email')"
              v-model="user.email"
              dense
              filled
              :error-messages="emailErrors"
              @input="$v.user.email.$touch()"
              @blur="$v.user.email.$touch()" />

            <v-text-field 
              class="item mb-3"
              color="white"
              persistent-hint
              outlined
              prepend-inner-icon="mdi-whatsapp"
              :label="$t('cadastro.whatsapp')"
              v-model="user.phone"
              dense
              filled
              type="tel"
              v-mask="['(##) #####-####']"
              :error-messages="phoneErrors"
              @input="$v.user.phone.$touch()"
              @blur="$v.user.phone.$touch()" />

            <v-text-field 
              class="item mb-4"
              color="white"
              outlined
              filled
              :type="showPassword ? 'text' : 'password'" 
              :label="$t('auth.password')"
              prepend-inner-icon="mdi-key"
              v-model="user.password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              dense
              :error-messages="passwordErrors"
              @input="$v.user.password.$touch()" 
              @blur="$v.user.password.$touch()" />

            <v-text-field 
              class="item"
              color="white"
              outlined
              filled
              :type="showConfirmPassword ? 'text' : 'password'" 
              :label="$t('cadastro.confirmeSenha')"
              prepend-inner-icon="mdi-key"
              v-model="user.confirmPassword"
              :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showConfirmPassword = !showConfirmPassword"
              dense
              :error-messages="confirmPasswordErrors"
              @input="$v.user.confirmPassword.$touch()" 
              @blur="$v.user.confirmPassword.$touch()" />

            <v-checkbox
              v-model="user.termsAccepted"
              :error-messages="termsErrors"
              @change="$v.user.termsAccepted.$touch()"
              class="mt-3 terms-checkbox"
              dense
              color="green"
            >
              <template v-slot:label>
                <div class="terms-label">
                  {{ $t('cadastro.euAceito') }}
                  <a
                    href="#"
                    @click.prevent="openTermsDialog"
                    class="terms-link"
                  >
                    {{ $t('cadastro.termosCondicoes') }}
                  </a>
                </div>
              </template>
            </v-checkbox>

          </v-card-text>

          <v-card-actions class="justify-center">
            <v-btn type="submit" color="primary" @click.prevent="submit" class="cadastro-btn" tile :loading="loading">{{ $t('cadastro.cadastrarBtn') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>

      <p class="text-cadastro mt-2"> {{ $t('cadastro.jaTemConta') }} <router-link to="/auth"> {{ $t('auth.loginTitle') }} </router-link></p>
    </div>

    <BrSnackbar :snackbar="snackbar" />

    <v-dialog
      v-model="termsDialog"
      max-width="900"
      scrollable
    >
      <v-card class="terms-modal-card">
        <v-card-title class="headline terms-modal-title">
          {{ $t('cadastro.termosTitulo', { brand: brand.legalName }) }}
          <v-spacer></v-spacer>
          <v-btn icon @click="termsDialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider class="terms-divider"></v-divider>

        <v-card-text class="pt-4 terms-modal-content" style="max-height: 600px;">
          <div class="terms-content" v-html="termsContent"></div>
        </v-card-text>

        <v-divider class="terms-divider"></v-divider>

        <v-card-actions class="pa-4 terms-modal-actions">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="acceptTerms"
            large
          >
            {{ $t('cadastro.concordoTermos') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators'
import variables from '@/assets/styles/helpers/_variables.scss'
import { mask } from 'vue-the-mask'
import storage from '@/core/service/localStorage'
import { size } from 'lodash'
import brand from '@/core/brand'
import legalContent from '@/core/brand/legal'

export default {
  name: 'Cadastro',
  mixins: [validationMixin],
  directives: { mask },
  components: {
    BrSnackbar: () => import('@/views/components/snackbar'),
  },

  data: () => ({
    show: false,
    snackbar: {
      toggle: false,
      type: null,
      msg: null
    },
    loading: false,
    showPassword: false,
    showConfirmPassword: false,
    valid: true,
    termsDialog: false,
    user: {
      name: '',
      email: '',
      phone: '',
      password: '',
      confirmPassword: '',
      termsAccepted: false
    }
  }),
  
  mounted(){
    setTimeout(() => {
      document.querySelector('#input-33').focus()
    })
  },
  computed: {
    variables: () => variables,
    brand: () => brand,
    termsContent: () => legalContent,
    appVersion () {
      return process.env.VUE_APP_VERSION
    },
    nameErrors () {
      const errors = []
      if (!this.$v.user.name.$dirty) return errors
      !this.$v.user.name.required && errors.push(this.$t('auth.nameRequired'))
      !this.$v.user.name.minLength && errors.push(this.$t('cadastro.nomeMinCaracteres'))
      return errors
    },
    emailErrors () {
      const errors = []
      if (!this.$v.user.email.$dirty) return errors
      !this.$v.user.email.required && errors.push(this.$t('cadastro.emailRequired'))
      !this.$v.user.email.email && errors.push(this.$t('cadastro.emailInvalido'))
      return errors
    },
    phoneErrors () {
      const errors = []
      if (!this.$v.user.phone.$dirty) return errors
      !this.$v.user.phone.required && errors.push(this.$t('cadastro.whatsappRequired'))
      !this.$v.user.phone.minLength && errors.push(this.$t('cadastro.whatsappMinCaracteres'))
      return errors
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.user.password.$dirty) return errors
      !this.$v.user.password.required && errors.push(this.$t('cadastro.senhaRequired'))
      !this.$v.user.password.minLength && errors.push(this.$t('cadastro.senhaMinCaracteres'))
      return errors
    },
    confirmPasswordErrors () {
      const errors = []
      if (!this.$v.user.confirmPassword.$dirty) return errors
      !this.$v.user.confirmPassword.required && errors.push(this.$t('cadastro.confirmacaoRequired'))
      !this.$v.user.confirmPassword.sameAsPassword && errors.push(this.$t('cadastro.senhasNaoCoincidem'))
      return errors
    },
    termsErrors () {
      const errors = []
      if (!this.$v.user.termsAccepted.$dirty) return errors
      !this.$v.user.termsAccepted.checked && errors.push(this.$t('cadastro.termosRequired'))
      return errors
    }
  },

  methods: {
    ...mapActions('cadastro', ['cadastrarAfiliado', 'obterAfiliado']),
    ...mapActions('roles', ['clearAcl']),
    openTermsDialog () {
      this.termsDialog = true
    },
    acceptTerms () {
      this.user.termsAccepted = true
      this.$v.user.termsAccepted.$touch()
      this.termsDialog = false
    },
    async submit () {
      const self = this
      if (this.$v.user.$invalid) { 
        this.$v.user.$touch()
        return false 
      }

      this.loading = true

      const token = await window.grecaptcha.execute('6LeR49UfAAAAAO7J7vKDCD4vM-Lq5ZA_NsquS9J_', { action: 'affregistration' })
      
      // Create registration payload
      const phone = this.user.phone.replace(/\D/g, '').replace(/\D/g, '')
      const registrationData = {
        fullName: this.user.name,
        termsAccepted: this.user.termsAccepted,
        email: this.user.email,
        password: this.user.password,
        ddiPhone: '55',
        dddPhone: String(phone).substring(0, 2).trim(),
        phone: phone.substring(2, size(phone)),
        token: token
      }

      const referralId = storage.get('referralId')
      if (referralId) {
        await self.obterAfiliado({ referralId })
          .then(() => { registrationData.referralId = referralId })
          .catch(err => {
            console.log('obterAfiliado error', err)
          })
      }

      // TODO: Replace with your registration action
      self.cadastrarAfiliado(registrationData).then(() => {
        self.$router.replace('/revisao-conta')
      }).catch(e => {
        console.log('registration error', e)
        if (e === 'Afiliado_pendente') {
          this.$router.push({name: 'revisao-conta'})
          return
        }
        this.snackbar = { toggle: true, msg: e, type: 'error' }
        this.loading = false
        return false
      })
    }
  },

  validations () {
    return {
      user: {
        name: { required, minLength: minLength(3) },
        email: { required, email },
        phone: { required, minLength: minLength(15) },
        password: { required, minLength: minLength(6) },
        confirmPassword: { required, sameAsPassword: sameAs('password') },
        termsAccepted: { 
          checked: (value) => value === true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped src="@/assets/styles/auth.scss"></style>

<style lang="scss" scoped>
@import '@/assets/styles/helpers/_variables.scss';
// Sobrescrever o top: 15px do auth.scss com especificidade maior
.card-login ::v-deep .terms-checkbox label,
.card-login ::v-deep .terms-checkbox label:not(.v-label--active) {
  top: 2px !important;
  position: relative !important;
}

::v-deep .terms-checkbox {
  .v-input__slot {
    align-items: flex-start !important;
  }
  
  .v-input--selection-controls__input {
    margin-top: 2px !important;
  }
  
  .v-icon {
    color: $colorSuccess !important;
  }

  .v-input--is-label-active .v-icon,
  .v-input--is-dirty .v-icon {
    color: $colorSuccess !important;
  }
  
  // Checkbox não marcado - borda branca
  .v-input--selection-controls__ripple {
    &::before {
      border-color: rgba(255, 255, 255, 0.7) !important;
    }
  }
  
  // Aumentar o tamanho do checkbox
  .mdi-checkbox-blank-outline::before,
  .mdi-checkbox-marked::before {
    font-size: 24px !important;
    color: rgba(255, 255, 255, 0.9) !important;
  }
  
  .mdi-checkbox-marked::before {
    color: $colorSuccess !important;
  }
}

.terms-label {
  color: rgba(255, 255, 255, 0.95) !important;
  font-size: 14px;
  line-height: 1.5;
  margin-top: 2px;
  
  .terms-link {
    color: $colorSuccess;
    text-decoration: none;
    font-weight: 600;
    
    &:hover {
      text-decoration: underline;
      color: #66BB6A;
    }
  }
}

.terms-modal-card {
  background: linear-gradient(90deg, #090A14 3.02%, #0D0F1E 100%) !important;
  color: rgba(255, 255, 255, 0.95) !important;
}

.terms-modal-title {
  background: transparent !important;
  color: $colorSuccess !important;
  font-weight: 600 !important;
  padding-bottom: 16px !important;
}

.terms-divider {
  border-color: rgba(41, 195, 83, 0.3) !important;
}

.terms-modal-content {
  background: transparent !important;
}

.terms-modal-actions {
  background: transparent !important;
  padding-top: 16px !important;
}

.terms-content {
  color: rgba(255, 255, 255, 0.95);
  
  h3 {
    font-size: 16px;
    font-weight: 700;
    margin-top: 24px;
    margin-bottom: 12px;
    color: $colorSuccess;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  p {
    font-size: 14px;
    line-height: 1.8;
    margin-bottom: 16px;
    text-align: justify;
    color: rgba(255, 255, 255, 0.9);
    
    strong {
      font-weight: 700;
      color: #66BB6A;
    }
  }
  
  .highlight-text {
    background-color: rgba(41, 195, 83, 0.15);
    padding: 16px;
    border-left: 4px solid $colorSuccess;
    border-radius: 4px;
    font-weight: 500;
    color: #A5D6A7;
    margin: 20px 0;
  }
  
  .company-info {
    background-color: rgba(255, 255, 255, 0.05);
    padding: 16px;
    border-radius: 4px;
    margin: 24px 0;
    border: 1px solid rgba(41, 195, 83, 0.3);
    
    p {
      margin-bottom: 8px;
      text-align: left;
      color: rgba(255, 255, 255, 0.9);
      
      &:last-child {
        margin-bottom: 0;
      }
      
      strong {
        color: $colorSuccess;
      }
    }
  }
  
  ul {
    margin-left: 20px;
    margin-bottom: 16px;
    
    li {
      font-size: 14px;
      line-height: 1.8;
      margin-bottom: 8px;
      color: rgba(255, 255, 255, 0.9);
    }
  }
}
</style>